import { personalRoutes } from './routes/personalRoutes.tsx';
import { businessRoutes } from './routes/buisnessRoutes.tsx';
import { yellowLaneRoutes } from './routes/yellowLaneRoutes.tsx';
import { finishingRoutes } from './routes/finishingRoutes.tsx';
import { rootRoute } from './routes/rootRoute.tsx';
import { ownerRoutes } from './routes/ownerRoutes.tsx';
import { inviteTeamMemberRoutes } from './routes/inviteTeamMemberRoutes.tsx';

export const routeTree = rootRoute.addChildren([
  ...finishingRoutes,
  ...yellowLaneRoutes,
  ...businessRoutes,
  ...personalRoutes,
  ...ownerRoutes,
  ...inviteTeamMemberRoutes,
]);
